import Vue from 'vue';

export default class Event {
  static vue: Vue = new Vue();

  static fire(event: string, data: any = null): void {
    Event.vue.$emit(event, data);
  }

  static listen(event: string, callback: (data: any) => void): void {
    Event.vue.$on(event, callback);
  }
}